import { Box } from "@mui/material";
import { FileMenu as FileMenuGroup } from "./FileMenuGroup";
import { HelpMenuGroup } from "./HelpMenuGroup";
import { MenuGroupFactory } from "./MenuGroupFactory";
import { useAtomValue } from "jotai";
import { currentViewTypeAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";
import { useMemo } from "react";

export function MainMenu() {
  const viewType = useAtomValue(currentViewTypeAtom);
  const contextMenuGroupsArray = useMemo(
    () => MenuGroupFactory.getForView(viewType ?? "spreadsheet"),
    [viewType]
  );
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "space-between",
        width: "15%",
      }}
    >
      <FileMenuGroup />
      {contextMenuGroupsArray}
      <HelpMenuGroup />
    </Box>
  );
}
